import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cardValidator from 'card-validator';
import creditCardType, { getTypeInfo, types } from 'credit-card-type';
import luhn10 from 'card-validator/src/luhn-10';
import { assertFunction, assertString, invert, splice } from '../../../utils';
creditCardType.addCard({
  code: {
    name: 'CVV',
    size: 3
  },
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  niceType: 'Carte Bancaire',
  patterns: [],
  type: 'cb-nationale'
});
creditCardType.addCard({
  code: {
    name: 'CVV',
    size: 3
  },
  gaps: [4, 8, 12, 16],
  lengths: [19],
  niceType: 'Carte Aurore',
  patterns: [],
  type: 'cetelem'
});
creditCardType.addCard({
  code: {
    name: '',
    size: 0
  },
  gaps: [4, 8, 12, 16],
  lengths: [17],
  niceType: 'Cofinoga ou Privilège',
  patterns: [],
  type: 'cofinoga'
});
creditCardType.addCard({
  code: {
    name: '',
    size: 0
  },
  gaps: [4, 8],
  lengths: [8, 9],
  niceType: '4 étoiles',
  patterns: [],
  type: 'cofidis'
});
var VALIDATOR_TO_TYPE_MAP = {
  [types.AMERICAN_EXPRESS]: 'AMEX',
  [types.DINERS_CLUB]: 'DINERS',
  [types.DISCOVER]: 'DISCOVER',
  [types.ELO]: 'ELO',
  [types.HIPER]: 'HIPER',
  [types.HIPERCARD]: 'HIPERCARD',
  [types.JCB]: 'JCB',
  [types.MASTERCARD]: 'MASTER_CARD',
  [types.MAESTRO]: 'MAESTRO',
  [types.UNIONPAY]: 'CHINA_UNION_PAY',
  [types.VISA]: 'VISA',
  'cb-nationale': 'CB_NATIONALE',
  cetelem: 'CETELEM',
  cofidis: 'COFIDIS',
  cofinoga: 'COFINOGA'
};
var TYPE_TO_VALIDATOR_MAP = invert(VALIDATOR_TO_TYPE_MAP);
var DEFAULT_TYPE = {
  code: {
    name: 'CVV',
    size: 3
  },
  gaps: [4, 8, 12],
  lengths: [16],
  niceType: 'Unknown',
  patterns: [],
  type: 'DEFAULT'
};

var detectCardType = number => {
  var _creditCardType;

  var cardType = (_creditCardType = creditCardType(number)) === null || _creditCardType === void 0 ? void 0 : _creditCardType[0];

  if (cardType) {
    return _objectSpread(_objectSpread({}, cardType), {}, {
      type: VALIDATOR_TO_TYPE_MAP[cardType.type]
    });
  }

  return null;
};

export var getCardType = (number, allowedTypes) => {
  if (!number) {
    return DEFAULT_TYPE;
  }

  assertString(number);
  var cardType = detectCardType(number);
  return allowedTypes.includes(cardType === null || cardType === void 0 ? void 0 : cardType.type) ? cardType : DEFAULT_TYPE;
};
export var getCardTypeInfo = function getCardTypeInfo() {
  var cardType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DEFAULT';
  assertString(cardType);
  var mapped = TYPE_TO_VALIDATOR_MAP[cardType];

  if (!mapped) {
    return DEFAULT_TYPE;
  }

  var typeInfo = getTypeInfo(mapped);
  return _objectSpread(_objectSpread({}, typeInfo), {}, {
    type: cardType
  });
};
export var subtractLastDigitOfCardNumber = cardNumber => {
  assertString(cardNumber);

  if (!cardNumber.length) {
    return cardNumber;
  }

  var lastIndex = cardNumber.length - 1;
  var lastDigit = parseInt(cardNumber.charAt(lastIndex), 10);
  var subtrahend = 1;
  var addend = (10 - subtrahend % 10) % 10;
  var result = (lastDigit + addend) % 10;
  return cardNumber.slice(0, lastIndex) + result.toString();
};

var validateJawsCard = (cardNumber, validator) => {
  assertString(cardNumber);
  assertFunction(validator);
  return validator(subtractLastDigitOfCardNumber(cardNumber));
};

export var validateCard = (number, cardType, luhnValidateJaws) => {
  var _result$card;

  assertString(number);
  var testCardValue = String(number).replace(/-|\s/g, '');
  var cardTypeInfo = cardType || detectCardType(testCardValue);

  if (!cardTypeInfo || !/^\d+$/.test(testCardValue)) {
    return {
      card: null,
      isPotentiallyValid: false,
      isValid: false
    };
  }

  if (cardTypeInfo.patterns.length < 1) {
    var maxLength = Math.max.apply(null, cardTypeInfo.lengths);
    var validLength = cardTypeInfo.lengths.some(length => length === testCardValue.length);
    var validLuhn = luhn10(testCardValue) || cardTypeInfo.type === 'COFIDIS' || luhnValidateJaws && validateJawsCard(testCardValue, luhn10);
    return {
      card: cardTypeInfo,
      isPotentiallyValid: validLength || testCardValue.length < maxLength,
      isValid: validLength && validLuhn
    };
  }

  var result = cardValidator.number(testCardValue);

  if (!result.isValid && luhnValidateJaws) {
    result = validateJawsCard(testCardValue, cardValidator.number);
  }

  if ((_result$card = result.card) !== null && _result$card !== void 0 && _result$card.type) {
    result.card.type = VALIDATOR_TO_TYPE_MAP[result.card.type];
  }

  return result;
};
export var maskCard = (number, cardType) => {
  var _detectCardType;

  assertString(number);
  number = number.trim();
  var gaps = (cardType === null || cardType === void 0 ? void 0 : cardType.gaps) || ((_detectCardType = detectCardType(number)) === null || _detectCardType === void 0 ? void 0 : _detectCardType.gaps);

  if (gaps) {
    for (var idx = 0; idx < gaps.length; idx++) {
      var splicePoint = gaps[idx] + idx;

      if (splicePoint > number.length - 1) {
        break;
      }

      number = splice(number, splicePoint, ' ');
    }
  }

  return number;
};